import { useEffect, useState } from 'react'
import { useTypingStore, freshTypers, typingLabel } from '@/store/typing'
import { useAuthStore } from '@/store/auth'

/**
 * Texto do indicador "digitando" da conversa `cid` (ex.: "Ana está digitando…"),
 * ou null quando ninguém está digitando. Lê o store de presença, ignora o
 * próprio usuário e expira entradas antigas — re-avalia a cada 1.5s para o
 * indicador sumir mesmo sem chegar um evento de "parou".
 */
export function useTypingIndicator(cid: number): string | null {
  const entries = useTypingStore((s) => s.byConv[cid])
  const selfId = useAuthStore((s) => s.user)?.id ?? null
  const [, tick] = useState(0)

  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 1500)
    return () => clearInterval(t)
  }, [])

  return typingLabel(freshTypers(entries, selfId, Date.now()))
}
